import styled from 'styled-components'
import { LIGHTGRAY } from '../../../styles/colors.style'
import { isMobile } from './../../../services/breakpoints.service'

export const StyledContainer = styled.div`
	border-radius: 5px;
	box-sizing: border-box;
	cursor: pointer;
	padding: 10px;
	transition: box-shadow 0.2s;
	

	&:hover {
		box-shadow: 0px 1px 12px 3px ${LIGHTGRAY};
	}

	&:active {
		box-shadow: 0px 1px 8px 2px ${LIGHTGRAY};
	}
`

export const StyledImg = styled.img`
	border-radius: 5px;
	max-height: 100%;
	max-width: 100%;
`

export const StyledImgContainer = styled.div`
	align-items: center;
	border-radius: 5px;
	display: flex;
	height: 192px;
	justify-content: center;
`

export const StyledPointsContainer = styled.span`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
`

export const StyledSecondOption = styled.span`
	display: inline-block;
	${() => (isMobile() ? '' : 'font-size: 2rem;')}
	padding: 10px 0px;
`

export const StyledForSubscribers = styled.span`
	display: inline-block;
	margin-top: 7px;
`

export const StyledForSubscribersPoints = styled.span`
	display: inline-block;
	${() => (isMobile() ? '' : 'font-size: 2rem;')}
`

export const LineTitleWrapper = styled.span`
	align-items: center;
	display: flex;
	flex-direction: row;
`

export const LineTitleLeft = styled.span`
	background: ${LIGHTGRAY};
	flex-grow: 1;
	height: 1px;
	margin-right: 7px;
`

export const LineTitleRight = styled.span`
	background: ${LIGHTGRAY};
	flex-grow: 1;
	height: 1px;
	margin-left: 7px;
`
